import { AppleIcon, Button } from '@iheartjane/reefer';
import type { ButtonProps } from '@iheartjane/reefer';

interface AppleButtonProps extends ButtonProps {
  label: string;
  loaded: boolean | undefined;
  onClick: () => void;
}
export const AppleButton = ({
  onClick,
  loaded,
  label,
  ...buttonProps
}: AppleButtonProps) => {
  return (
    <Button
      disabled={!loaded}
      full
      label={label}
      onClick={onClick}
      startIcon={<AppleIcon size="sm" color={null} />}
      variant="tertiary"
      {...buttonProps}
    />
  );
};
